import React from 'react'
import 'styles/CircledItem.css'

export default function CircledItem ({children, ...props}) {
  return (
    <div class="CircledItem" {...props}>{children}</div>)
}
